module.exports = __webpack_public_path__ + "img/pince-tampons-alphabet.8d30fb50.jpg";